module.exports = __webpack_public_path__ + "images/emoji/pizza.486cf5f539065838329a.png";